import { Box, Container } from "@mui/material"
import { FC } from "react"
import { UsefulLinks } from "../../pr/components"

interface IProps {}
export const Footer: FC<IProps> = (props) => {
  return (
    <Box
      component="footer"
      sx={(theme) => ({
        minHeight: 100,
        display: "flex",
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        marginTop: 2,
        py: 4,
      })}
    >
      <Container maxWidth="xl">
        <UsefulLinks />
      </Container>
    </Box>
  )
}
